<template>
  <div>
    <b-form class="mt-2" @submit="onSubmit">
      <b-row>
        <b-col md="6">
          <b-form-group label="Blackboard course name">
            <b-form-input v-model="bbCourseName" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Blackboard course ID">
            <b-form-input v-model="bbCourseID"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group label="Blackboard URL">
            <b-form-input v-model="bbURL" type="url"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row align-h="end">
        <b-button class="mr-3" type="submit" variant="primary">Submit</b-button>
      </b-row>
    </b-form>
  </div>
</template>

<script>
  import { getTodaysDate } from '@/utils/index.js'

  export default {
    name: 'GCreateDevSitesForm',
    props: { site: Object },
    data() {
      return {
        today: getTodaysDate(),
        bbCourseName: null,
        bbCourseID: null,
        bbURL: null
      }
    },
    methods: {
      async onSubmit() {
        const payload = {
          createdDate: this.today,
          bbCourseName: this.bbCourseName.trim(),
          bbCourseID: this.bbCourseID.trim(),
          bbURL: this.bbURL.trim(),
          authorID: this.$store.state.courseDev.user.currentUser.id,
          projectID: this.site.project.id
        }
        try {
          const response = await this.$store.dispatch('createDevSite', payload)
          console.dir(response)
          this.$root.$bvToast.toast(
            `${JSON.stringify(response.data.message)}`,
            {
              title: 'Success',
              autoHideDelay: 1000,
              toaster: 'b-toaster-top-center',
              variant: 'success'
            }
          )
        } catch (err) {
          console.error(err)
          this.$bvToast.toast(`${err}`, {
            title: 'Unsuccessful',
            toaster: 'b-toaster-top-center',
            variant: 'danger'
          })
        }
      }
    }
  }
</script>

<style scoped></style>
